module.exports = __webpack_public_path__ + "static/6_Welcome-7c0b9d276664e95c28ff57b7e5c84c74.png";